/**
 * Open a full document create page in a new tab. Used for sales, purchase,
 * and transfer orders so the origin form is not replaced by a drawer.
 *
 * @param {string} path App path such as /sales/order/create.
 * @return {void}
 */
export const openCreateInNewTab = path => {
  window.open(path, "_blank", "noopener,noreferrer");
};
